// src/utils/clientErrorReporter.js
import { callCloudFunctionNoAuth } from "../helpers/cloudFunctionRequests"

export const reportClientError = async (payload) => {
  try {
    await callCloudFunctionNoAuth("reportClientError", payload)

  } catch (err) {
    console.warn("Failed to send error report:", err)
  }
}
